import { FC, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";

import {
  getLandingCompanyIdByPath,
  useLandingsNavigation,
} from "@ryde/utils-landings";

import { GenericLandingPage } from "../generic-landing";

export const LandingPageByRouteCompanyName: FC = () => {
  const { companyName } = useParams<Record<"companyName", string>>();
  const { navigatePageNotFound } = useLandingsNavigation();

  const companyIdComputed = useMemo(() => {
    if (!companyName) {
      return undefined;
    }

    return getLandingCompanyIdByPath(companyName);
  }, [companyName]);

  useEffect(() => {
    if (!companyIdComputed) {
      navigatePageNotFound();
    }
  }, [companyIdComputed, navigatePageNotFound]);

  return (
    companyIdComputed && <GenericLandingPage companyId={companyIdComputed} />
  );
};
